<script setup>
import Authentication from './Authentication.vue'
import { ref, computed } from 'vue'
import { store } from '@/store/index.js'

const isMenuOpen = ref(false)
const menuToggleRef = ref(null)

//const useExternalOidc = process.env.VUE_APP_AUTH_PROVIDER === 'external_oidc'

const oidcUser = computed(() => {
  return store.state.oidc?.user || {}
})


const oidcProviderName = computed(() => {
  return oidcUser.value.identities?.[0]?.providerName || null
})

const useExternalOidc = computed(() => {
  return (
   oidcProviderName.value === 'MAN'||oidcProviderName.value === 'NAVISTAR'
    //||oidcProviderName.value === 'SCANIA'
  )
})


const oidcIsAuthenticated = computed(() => {
  return (
    !!store.state.oidc?.access_token &&
    store.state.oidc?.expires_at > Date.now()
  )
})

const oidcRoles = computed(() => {
  const user = store.state.oidc?.user || {}

  const roles =
    user.roles ||
    user['cognito:groups'] ||
    []

  return Array.isArray(roles) ? roles : [roles]
})

const hasOidcRole = (roles) => {
  return roles.some(role => oidcRoles.value.includes(role))
}

const isAuthenticated = computed(() => {
  if (useExternalOidc.value) {
    return oidcIsAuthenticated.value
  }
   return store.state.bearerToken !== null
})

const userHaveBasicRoleAccess = computed(() => {
  console.log(useExternalOidc.value)
  if (useExternalOidc.value) {
    return hasOidcRole([
      'ODP_unlimited',
      'ODP_limited',
      'YQI_Users'
    ])
  }

  return (
    store.state.isODP_unlimited ||
    store.state.isODP_limited ||
    store.state.isYQI_Users
  )
})

const isTester = computed(() => {
  if (useExternalOidc.value) {
    return hasOidcRole([
      'RnDAdvancedAnalysisPlatform'
    ])
  }

  return store.state.isRnDAdvancedAnalysisPlatform
})
const isCLAPTeam = computed(() => {
  if (useExternalOidc.value) {
    return hasOidcRole([
      'AP3610001-CLAPUsers'
    ])
  }

  return store.state.isAP3610001CLAPUsers
})
const isFreudUser = computed(() => {
  if (useExternalOidc.value) {
    return hasOidcRole([
      'Freud_standard'
    ])
  }

  return (
    store.state.isFreudUser 
  )
})

const closeMenu = () => {
  isMenuOpen.value = false

  if (menuToggleRef.value) {
    menuToggleRef.value.classList.remove('active')
  }
}
</script>

<template>
  <div class="navigation">
    <nav :class="{ 'active': isMenuOpen }">
      <ul class="menu-list">
        <!-- Home with Dropdown -->
        <li class="menu-item">
          <router-link
              to="/"
              class="parent"
              @click="closeMenu"
          >
            <font-awesome-icon
                icon="fa-house"
                class="menu-icon"
            />
          </router-link>
          <ul class="dropdown">
            <li>
              <a
                  href="https://scaniaazureservices.sharepoint.com/sites/ECCD-DDM/_layouts/15/Doc.aspx?sourcedoc=%7B81b417fc-58b5-445a-aefb-bd306a29e0a0%7D&action=edit&wd=target%28General+information.one%7C1f9a0475-0c6b-44a2-a317-f2855c14603d%2FIntroduction%7Ca8830073-a4bb-44b8-89d2-7c9dcf10254e%2F%29&wdorigin=703&wdpartid=%7B5a10b102-5f71-400a-be83-0d4a9a7d874d%7D%7B1%7D&wdsectionfileid=%7B02a38a13-d6f5-468a-afbd-1d93d7983027%7D"
                  target="_blank"
              >
                User Guide
              </a>
            </li>
            <li>
              <a
                  href="https://teams.microsoft.com/l/channel/19%3aaead27f3b99c4cf9b0303d5c428fee60%40thread.skype/Product%2520Analytics%2520-%2520Questions?groupId=009a383b-d7c9-42e5-a947-a32fa571402b&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac"
                  target="_blank"
              >
                Contact Us
              </a>
            </li>
          </ul>
        </li>

        <!-- Other Navigation Links -->
        <li v-if="isAuthenticated && (isTester || isFreudUser|| userHaveBasicRoleAccess)" class="menu-item">
          <router-link
              to="/one-product-mode"
              class="parent"
              @click="closeMenu"
          >
            One Product Search
            <span class="badge badge-primary inverted-badge">NEW</span>
          </router-link>
        </li>
        <div v-if="isAuthenticated && (isTester || isFreudUser|| userHaveBasicRoleAccess)"
             class="vertical-line"></div>

        <li v-if="isAuthenticated && userHaveBasicRoleAccess" class="menu-item">
          <router-link
              to="/report-creation"
              class="parent"
              @click="closeMenu"
          >
            Multi Product Search
          </router-link>

          <ul class="dropdown">
            <li>
              <router-link
                  to="/report-creation/modular-queries"
                  @click="closeMenu"
              >
                Modular Queries
              </router-link>
            </li>
            <li v-if="isAuthenticated && isTester">
              <router-link
                  to="/report-creation/streamline-method"
                  @click="closeMenu"
              >
                DTC Grouping
              </router-link>
            </li>
          </ul>
        </li>
        <div v-if="isAuthenticated && userHaveBasicRoleAccess" class="vertical-line"></div>

        <li v-if="isAuthenticated && (isTester || isFreudUser)" class="menu-item">
          <router-link
              to="/test-product-diagnostics"
              class="parent"
              @click="closeMenu"
          >
            Test Product Diagnostics
          </router-link>
        </li>
        <div v-if="isAuthenticated && userHaveBasicRoleAccess" class="vertical-line"></div>

        <li v-if="isAuthenticated && (isCLAPTeam)" class="menu-item">
          <router-link
              to="/logging-data-explorer"
              class="parent"
              @click="closeMenu"
          >
            Logging Data Explorer
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="menu-links">
      <div class="vertical-line"></div>
      <div>
        <Authentication/>
      </div>
    </div>
  </div>
</template>

<style scoped>
.menu-icon {
  font-size: 20px; /* Adjust the size */
  color: #033a6a; /* Keep your existing color */
  transition: transform 0.3s ease, color 0.3s ease;
  cursor: pointer;
  margin-left: 10px;
}

/* Hover Effect: Slightly enlarge and change color */
.menu-icon:hover {
  color: #025090; /* A lighter shade for a professional effect */
  transform: scale(1.2);
}

/* Click Effect: Rotate slightly for a subtle interactive feel */
.menu-icon:active {
  transform: scale(1.1) rotate(10deg);
}

/* Styling for navigation */
.navigation {
  display: flex;
  align-items: center;
  position: relative;
  padding: 12px;
  z-index: 999; /* Ensure the navigation stays on top of other content */
}

.menu-toggle {
  width: 40px; /* Adjust width as needed */
  height: 30px; /* Adjust height as needed */
  position: relative;
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0;
}

.menu-toggle:focus {
  outline: none;
}

nav ul.menu-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: flex-start;
  padding-top: 90px; /* Adjust based on navigation height */
}

.menu-list .menu-item {
  position: relative; /* For dropdown positioning */
  margin-right: 20px;
  /* width: fit-content; */
}

.menu-list .menu-item .dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 10px 0;
  margin: 0;
  border-radius: 4px;
  width: 200px;
  z-index: 1000;
}

.menu-list .menu-item:hover .dropdown {
  display: block;
}

.menu-list .dropdown li {
  padding: 10px 20px;
}

.menu-list .dropdown li a {
  color: #333;
  text-decoration: none;
  display: block;
}

.menu-list .dropdown li a:hover {
  background-color: #f1f1f1;
}

.menu-list .parent {
  color: #333;
  text-decoration: none;
  margin-right: 25px;
}

.menu-list .badge {
  font-size: 0.9em;
  margin-left: 5px;
}

hr {
  width: 100%;
  border: 1px solid #ccc;
  margin: 10px 0;
}

.inline-link {
  display: inline-block;
  margin-right: 10px;
}

.menu-links {
  margin-top: 80px;
  display: flex;
  align-items: center;
  margin-left: auto; /* Push content to the right */
  gap: 15px; /* Add space between items */
  z-index: 1000;
}

.vertical-line {
  border-left: 1px solid #ccc;
  height: 30px;
  margin-right: 10px;
}

/* Optional: Mobile Responsiveness */
@media (max-width: 768px) {
  nav ul.menu-list {
    flex-direction: column;
  }

  .menu-toggle {
    display: block; /* Show the toggle button on small screens */
  }
}

/* Style for active router-link */
.router-link-active {
  font-weight: bold;
}
</style>